// src/services/mrpService.js

import { BASE_URL } from 'BaseURL'; 
// e.g. export const BASE_URL = 'http://localhost:8000/'

const mrpService = {
  async fetchWeeklyDemandData(params = {}) {
    // Build a direct string (avoid "new URL(..., window.location.origin)")
    let url = `${BASE_URL}mrp/weekly-demand/`;

    const query = new URLSearchParams();
    if (params.year) query.set('year', params.year);
    if (params.batch_name) query.set('batch_name', params.batch_name);
    const queryString = query.toString();
    if (queryString) url += `?${queryString}`;

    const resp = await fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'include', // if you need cookies for session/csrf
    });
    if (!resp.ok) {
      throw new Error(`Failed GET with status ${resp.status}`);
    }
    return resp.json();
  },

  async createWeeklyDemands(payload) {
    const url = `${BASE_URL}mrp/weekly-demand/`;

    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include', // if you need session/csrf cookies
      body: JSON.stringify(payload),
    });
    if (!resp.ok) {
      const errData = await resp.json().catch(() => ({}));
      throw new Error(errData.msg || `Error creating demands: status ${resp.status}`);
    }
    return resp.json();
  },
};

export default mrpService;
